module.exports = __webpack_public_path__ + "png/find-friends.png?b7a1283b53051b338d3fc52c9ab9023b";